import { Info } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

export const InfoTip = ({ text, testId, className }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        type="button"
        aria-label="More information"
        data-testid={testId}
        className={cn("inline-flex text-ink-muted hover:text-brand transition-colors duration-150 align-middle", className)}
      >
        <Info size={14} />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-xs bg-ink text-white leading-relaxed">{text}</TooltipContent>
  </Tooltip>
);

export const EmptyState = ({ icon: Icon, title, text, action, testId }) => (
  <div data-testid={testId} className="panel flex flex-col items-start gap-3 p-8 sm:p-10">
    {Icon && (
      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-tint text-brand">
        <Icon size={20} />
      </div>
    )}
    <h3 className="text-lg font-semibold text-ink">{title}</h3>
    {text && <p className="max-w-lg text-sm text-ink-secondary leading-relaxed">{text}</p>}
    {action && <div className="pt-1">{action}</div>}
  </div>
);

export const PageHeader = ({ title, subtitle, actions, children }) => (
  <div className="flex flex-wrap items-start justify-between gap-4">
    <div className="space-y-1">
      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-ink" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm text-ink-secondary">{subtitle}</p>}
      {children}
    </div>
    {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export const Skel = ({ className }) => <div className={cn("tl-skel", className)} />;

export const SkeletonRows = ({ rows = 4 }) => (
  <div className="panel p-6 space-y-4" data-testid="skeleton-loader">
    {Array.from({ length: rows }).map((_, i) => (
      <Skel key={i} className="h-5 w-full" />
    ))}
  </div>
);
